import { render } from "./MsPowerpoint.vue?vue&type=template&id=2d5e1b52&scoped=true"
import script from "./MsPowerpoint.vue?vue&type=script&lang=js"
export * from "./MsPowerpoint.vue?vue&type=script&lang=js"

import "./MsPowerpoint.vue?vue&type=style&index=0&id=2d5e1b52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5e1b52"]])

export default __exports__